import { downloadAsset, helperCreateObjectUrl } from "~/solidJs/shared/helpers";
import { $div } from "../utilities/TurboDom";
export default class Viewer {
	/**
	 * @type {SocketOut}
	 */
	socketsOutput;
	constructor(asset, socketsOutput = null, socketName = null) {
		this.asset = asset;
		this.socketsOutput = socketsOutput;
		this.socketName = socketName;

		this.dom = {};
		this.dom.viewer = document.createElement("div");
		this.dom.hoverFeatureMount = $div(
			"absolute w-full h-full left-0 top-0 pointer-events-none",
			this.dom.viewer
		);
		this.dom.viewer.classList.add("viewer");
		this.dom.viewer.classList.add(this.getViewerType());
		this.dom.viewerContainer = document.createElement("div");
		this.dom.viewerContainer.classList.add("viewer-container");
		this.dom.viewerContainer.append(this.dom.viewer);

		this.isOpen = false;
	}

	getViewerType() {
		return "base";
	}

	// Hover functionality now handled by SolidJS HoverFeatureMenu

	async getAsset() {
		return this.asset;
	}

	// Hover methods moved to HoverFeatureMenu handlers

	async downloadAsset() {
		if (this.asset.type === "text") {
			const textBlob = new Blob([this.asset.value], { type: "text/plain" });
			downloadAsset(textBlob);
			a.href = helperCreateObjectUrl(textBlob);
		} else {
			downloadAsset(this.asset);
		}
	}
	/**
	 *
	 * @returns {HTMLDivElement}
	 */
	domElement() {
		return this.dom.viewer;
	}

	hoverFeatureMount() {
		return this.dom.hoverFeatureMount;
	}

	domElementAppend() {
		return this.dom.viewerContainer;
	}
	setTitle(title) {
		this.dom.title = document.createElement("div");
		this.dom.title.classList.add("title");
		this.dom.title.innerHTML = title;
		this.dom.viewer.appendChild(this.dom.title);
	}

	loadAsync() {}

	reloadAssetAsync() {}
}
